export default "__VITE_ASSET__DDOM2Vnz__"